import styled from "styled-components";

const Header = styled.div`
  img {
    width: 480px;
    max-width: 100%;
    border-radius: 10px;
    border-bottom-right-radius: unset;
    border-bottom-left-radius: unset;
  }
`;

const Section = styled.div`
  padding: 16px;
  border-radius: 4px;
  background-color: #f4f5f8;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 510px) {
    flex-direction: column;
  }
`;

const Description = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: 510px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Icon = styled.div`
  width: 32px;
  height: 32px;
  box-shadow: 0 4px 40px 0 rgba(34, 41, 57, 0.25);
  background-color: #ffffff;
  font-size: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  @media (max-width: 510px) {
    margin-right: unset;
    margin-bottom: 16px;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  color: #003757;
  width: 243px;

  @media (max-width: 510px) {
    width: 100%;
    text-align: center;
    margin-bottom: 16px;
  }
`;

const Subtitle = styled.div`
  font-size: 14px;
  line-height: 1.43;
  font-weight: normal;
  color: #6f7582;
`;

const Select = styled.div`
  padding: 9px;
  border-radius: 2px;
  background-color: #ffffff;
  text-align: center;
`;

const SelectValue = styled.div`
  font-size: 22px;
  font-weight: bold;
  line-height: 1.09;
  color: #222939;
`;

const SelectInfo = styled.div`
  padding: 2px;
  border-radius: 2px;
  background-color: #ebf7ff;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: -0.13px;
  color: #003757;
`;

const Footer = styled.div`
  text-align: center;
  width: 100%;
  margin-top: 16px;
`;

export {
  Header,
  Section,
  Description,
  Icon,
  Title,
  Subtitle,
  SelectValue,
  SelectInfo,
  Footer,
  Select
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/modalConductor/SetYourGoalsModalStyle.js